import React from "react";
import "./sideApp.scss";
import "./newSiderStyle.css";
import Header from "./Header";

function MainHeader() {
  return (
    <div className="App">
      <Header className="position-ab" />
    </div>
  );
}

export default MainHeader;
